export default __webpack_public_path__ + "8b3ae4e.png";